import { axiosHelper } from 'Services/AxiosHelper';
import { OnCheckProductModel } from 'Models';
import { onCheckProductReqBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnCheckProduct';

const onCheckProduct = async (params: onCheckProductReqBodyData): Promise<OnCheckProductModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default onCheckProduct;
